/**
 * @private
 * @param status
 * @param statusText
 * @param message
 * @param data
 * @param meta
 * @returns {{payload: {data: *, statusText: *, message: *, status: *}, meta: *, type: string, error: boolean}}
 */
export default function createHttpErrorAction(status, statusText, message, data, meta) {
	return {
		type: 'HTTP_ERROR_OCCURRED',
		payload: {
			status,
			statusText,
			message,
			data
		},
		meta: {
			...meta,
			stopPropagation: false,
			status,
			statusText
		},
		error: true
	};
}
